// extracted by mini-css-extract-plugin
export default {"root":"bZylqr4rQxlxC4EHc7SM","embedded":"LysuOevUrudHVXNM_4s5","editMode":"fFmXbc287fZUXBZFVAKO"};
    if(module.hot) {
      // 1647894314787
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  